import {
  alertError
} from '@/functions'
export default {
  methods: {
    submit() {
      this.resource.save(this.form).then(
        a => {
          this.$router.push(".");
        }, alertError
      );
    },
    back(e) {
      e.preventDefault();
      this.$router.go(-1);
    }
  }
}
